/** @typedef {{ clientName: string; documentTitle: string; docDate: string; version: string }} DocumentMeta */

/** @typedef {"split" | "editor" | "preview"} FocusMode */

/**
 * @typedef {{
 *   v: 1;
 *   markdown: string;
 *   showLetterhead: boolean;
 *   showPrintPageNumbers: boolean;
 *   spellCheck: boolean;
 *   meta: DocumentMeta;
 * }} PersistedDocumentV1
 */

/** @type {DocumentMeta} */
export const EMPTY_META = {
  clientName: "",
  documentTitle: "",
  docDate: "",
  version: "",
};
